import { IFundRule } from '../rules/ifund-rule'
import { FundCategoryModel } from './fund-category-model'

export class AggregateHandlerResultModel {
  constructor(
    private fundCategoryModelAry: FundCategoryModel[],
    private fundRuleAry: IFundRule[],
  ) {}

  public getFundCategoryList(): FundCategoryModel[] {
    return this.fundCategoryModelAry
  }

  public getRuleList(): IFundRule[] {
    return this.fundRuleAry
  }

  public isRuleListEmpty(): boolean {
    return !this.fundRuleAry || this.fundRuleAry.length === 0
  }
}
